"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.YUSDOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var YUSDOracleFactory = /** @class */ (function (_super) {
    __extends(YUSDOracleFactory, _super);
    function YUSDOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    YUSDOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    YUSDOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    YUSDOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    YUSDOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    YUSDOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return YUSDOracleFactory;
}(contracts_1.ContractFactory));
exports.YUSDOracleFactory = YUSDOracleFactory;
var _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "aaveRiskOracle",
        outputs: [
            {
                internalType: "contract IRiskOracle",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainlinkETHUSDAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "yUSDAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50600280546001600160a01b0319908116735dbcf33d8c2e976c6b560249878e6f1491bca25c17909155600180548216735f4ec3df9cbd43714fe2740f5e3616155c5b841917905560008054909116734cc91e0c97c5128247e71a5ddf01ca46f4fa8d1d1790556105a3806100866000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c8063156313301461005157806363d1060c1461006f5780638db3a84b1461007757806396a0e5e31461008c575b600080fd5b6100596100a1565b60405161006691906104cf565b60405180910390f35b6100596100b0565b61007f6100bf565b60405161006691906104c1565b6100946100ce565b604051610066919061050d565b6000546001600160a01b031681565b6001546001600160a01b031681565b6002546001600160a01b031681565b6100d6610381565b60025460408051631df1ee3f60e21b815290516000926001600160a01b0316916377c7b8fc916004808301926020929190829003018186803b15801561011b57600080fd5b505afa15801561012f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250610153919081019061039f565b905060008060009054906101000a90046001600160a01b03166001600160a01b03166350d25bcd6040518163ffffffff1660e01b815260040160206040518083038186803b1580156101a457600080fd5b505afa1580156101b8573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052506101dc919081019061039f565b9050600061027b6402540be400600160009054906101000a90046001600160a01b03166001600160a01b03166350d25bcd6040518163ffffffff1660e01b815260040160206040518083038186803b15801561023757600080fd5b505afa15801561024b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525061026f919081019061039f565b9063ffffffff61030916565b905060006102a7670de0b6b3a764000061029b858563ffffffff61030916565b9063ffffffff61034c16565b905060006102c7670de0b6b3a764000061029b878563ffffffff61030916565b9050600081116102f25760405162461bcd60e51b81526004016102e9906104fd565b60405180910390fd5b604080516020810190915290815294505050505090565b60008261031857506000610346565b8282028284828161032557fe5b04146103435760405162461bcd60e51b81526004016102e9906104ed565b90505b92915050565b600080821161036d5760405162461bcd60e51b81526004016102e9906104dd565b600082848161037857fe5b04949350505050565b6040518060200160405280600081525090565b805161034681610549565b6000602082840312156103b157600080fd5b60006103bd8484610394565b949350505050565b6103ce81610524565b82525050565b6103ce8161053e565b60006103ea601a8361051b565b7f536166654d6174683a206469766973696f6e206279207a65726f000000000000815260200192915050565b600061042360218361051b565b7f536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f8152607760f81b602082015260400192915050565b600061046660268361051b565b7f595553444f7261636c653a2063616e6e6f74207265706f727420612070726963815265065206f6620360d41b602082015260400192915050565b805160208301906104b284826104b8565b50505050565b6103ce8161052f565b6020810161034682846103c5565b6020810161034682846103d4565b60208082528101610346816103dd565b6020808252810161034681610416565b6020808252810161034681610459565b6020810161034682846104a1565b90815260200190565b600061034682610532565b90565b6001600160a01b031690565b600061034682610524565b6105528161052f565b811461055d57600080fd5b5056fea365627a7a72315820c99e855963c3f5f0346d07a00ad9fb035ebfeeffa8963e5556a56ff2f988ff926c6578706572696d656e74616cf564736f6c63430005100040";
//# sourceMappingURL=YUSDOracleFactory.js.map